/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Agent_Hr_NameInputs */

const en_mk_mock_agent_hr_name = /** @type {(inputs: Mk_Mock_Agent_Hr_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bimo`)
};

const id_mk_mock_agent_hr_name = /** @type {(inputs: Mk_Mock_Agent_Hr_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bimo`)
};

/**
* | output |
* | --- |
* | "Bimo" |
*
* @param {Mk_Mock_Agent_Hr_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_agent_hr_name = /** @type {((inputs?: Mk_Mock_Agent_Hr_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Agent_Hr_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_agent_hr_name(inputs)
	return en_mk_mock_agent_hr_name(inputs)
});